import { yupResolver } from "@hookform/resolvers/yup";
import { defaultFormValues as _defaultFormValues, schema } from "./constants";
import { LlmStrategyFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";

export interface LlmStrategyFormProps {
  defaultFormValues?: Partial<LlmStrategyFormValues>;
  children?: React.ReactNode;
}
export const LlmStrategyForm = ({
  defaultFormValues,
  children,
}: LlmStrategyFormProps) => {
  const methods = useForm<LlmStrategyFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
